module.exports = __webpack_public_path__ + "static/media/04_Quantum_One_AR_icon_preview.de905020.png";